import { atom } from 'recoil';
import { RecoilAtomKeys } from '../RecoilKeys';

const infomationState: any = atom({
    key: RecoilAtomKeys.GENESISES_USER_PARMAS,
    default: {
    },
});

const userIdTokenState: any = atom({
    key: RecoilAtomKeys.OKTA_USER_ID_TOKEN,
    default: {
    },
});

const userAtom = {
    infomationState,
    userIdTokenState,
};

export default userAtom;
